export function $(id) {
  return document.getElementById(id);
}

export function show(el, visible = true) {
  if (!el) return;
  el.hidden = !visible;
}

export function setStatus(el, message, kind = '') {
  if (!el) return;
  el.textContent = message;
  el.dataset.kind = kind;
}

export function toast(message, ms = 2200) {
  const el = $('toast');
  if (!el) return;
  el.textContent = message;
  el.hidden = false;
  clearTimeout(toast._t);
  toast._t = setTimeout(() => {
    el.hidden = true;
  }, ms);
}

export function bindHud() {
  return {
    hud: $('hud'),
    score: $('score-label'),
    timer: $('timer-label'),
    hint: $('hint'),
    vfxLayer: $('vfx-layer'),
    boot: $('boot'),
    results: $('results'),
    resultsSummary: $('results-summary'),
    resultsStatus: $('results-status'),
    capturePreview: $('capture-preview'),
    bootStatus: $('boot-status'),
    targetBanner: $('target-banner'),
    apiBase: $('api-base'),
    campaign: $('campaign'),
    btnAr: $('btn-ar'),
    btnTest: $('btn-test'),
    btnCapture: $('btn-capture'),
    btnReplay: $('btn-replay'),
    btnHome: $('btn-home'),
    canvas: /** @type {HTMLCanvasElement} */ ($('ar-canvas')),
  };
}

/** Estado del target .zpt en boot (sin cargar el SDK). */
export function setTargetBanner(ui, { present, detail = '' }) {
  if (!ui.targetBanner) return;
  if (present) {
    ui.targetBanner.dataset.kind = 'ok';
    ui.targetBanner.textContent =
      detail ||
      'Target .zpt listo — Image Tracking disponible. Imprime public/targets/challenge-target.png.';
  } else {
    ui.targetBanner.dataset.kind = 'warn';
    ui.targetBanner.textContent =
      detail ||
      'Fallback: falta challenge-target.zpt. Modo AR = cámara sin ancla. Usa «Modo prueba» o npm run train:target.';
  }
}

export function updateMeters(ui, snapshot) {
  ui.score.textContent = `${snapshot.score}/${snapshot.targetScore}`;
  ui.timer.textContent = `${(snapshot.remainingMs / 1000).toFixed(1)}s`;
  const meters = ui.timer?.closest?.('.meters');
  if (meters) {
    meters.dataset.urgent = snapshot.remainingMs <= 5000 && snapshot.status === 'playing' ? '1' : '0';
  }
  if (ui.hint && snapshot.status === 'playing' && snapshot.combo >= 3) {
    ui.hint.dataset.combo = String(snapshot.combo);
  } else if (ui.hint) {
    delete ui.hint.dataset.combo;
  }
}

export function showResults(ui, { score, result, targetScore }) {
  show(ui.hud, false);
  show(ui.boot, false);
  show(ui.results, true);
  const label =
    result === 'won'
      ? `¡Victoria! ${score}/${targetScore} orbes en 20s`
      : `Tiempo agotado · ${score}/${targetScore} orbes`;
  ui.resultsSummary.textContent = label;
}
